// extracted by mini-css-extract-plugin
export var jtbdCollection = "jtbd-collection-module--jtbd-collection--b01f4";
export var jtbdCollection1 = "jtbd-collection-module--jtbd-collection--1--9934e";
export var jtbdCollection2 = "jtbd-collection-module--jtbd-collection--2--42dbe";
export var jtbdCollection3 = "jtbd-collection-module--jtbd-collection--3--d8b0a";
export var jtbdCollection__card = "jtbd-collection-module--jtbd-collection__card--e0c76";
export var jtbdCollection__card1 = "jtbd-collection-module--jtbd-collection__card--1--8df9e";
export var jtbdCollection__card2 = "jtbd-collection-module--jtbd-collection__card--2--7c7a4";
export var jtbdCollection__card3 = "jtbd-collection-module--jtbd-collection__card--3--e12cb";
export var jtbdCollection__card4 = "jtbd-collection-module--jtbd-collection__card--4--85148";
export var jtbdCollection__card5 = "jtbd-collection-module--jtbd-collection__card--5--db048";
export var jtbdCollection__cardLast = "jtbd-collection-module--jtbd-collection__card--last--dde87";
export var jtbdCollection__item = "jtbd-collection-module--jtbd-collection__item--5994e";
export var mt0 = "jtbd-collection-module--mt-0--e82ef";
export var mt1 = "jtbd-collection-module--mt-1--381b7";
export var mt2 = "jtbd-collection-module--mt-2--09e01";
export var mt3 = "jtbd-collection-module--mt-3--d804c";
export var mt4 = "jtbd-collection-module--mt-4--89dcd";
export var mt5 = "jtbd-collection-module--mt-5--4210a";
export var mt6 = "jtbd-collection-module--mt-6--1ecf4";